import React,{useEffect,useRef} from 'react';
import {useLocation} from 'react-router-dom';
const ScrollToTop=()=>{
  const {pathname,search,hash}=useLocation();
  const prevPathnameRef=useRef(pathname);
  useEffect(()=>{
    if(!hash&&pathname.substring(3)!==prevPathnameRef.current.substring(3)){
      window.scrollTo({
        top:0,
        left:0,
        behavior:'auto',
      });
    }
    prevPathnameRef.current=pathname;
  },[pathname,search,hash]);
  return null;
};
export default ScrollToTop;

